<template>
  <div>
    <editor v-model="currentValue" :init="initData"></editor>
  </div>
</template>

<script>
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/plugins/image";
import "tinymce/themes/silver";
import "tinymce/plugins/preview";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/autolink";
import "tinymce/plugins/directionality";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/visualchars";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/link";
import "tinymce/plugins/media";
import "tinymce/plugins/template";
import "tinymce/plugins/code";
import "tinymce/plugins/codesample";
import "tinymce/plugins/table";
import "tinymce/plugins/charmap";
import "tinymce/plugins/pagebreak";
import "tinymce/plugins/nonbreaking";
import "tinymce/plugins/anchor";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/advlist";
import "tinymce/plugins/lists";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/help";
import "tinymce/plugins/emoticons";
import "tinymce/plugins/autosave";
import "tinymce/plugins/autoresize";
import "tinymce/icons/default";
import "./tinymce/skins/ui/oxide/skin.min.css";
import "./tinymce/skins/ui/oxide/content.min.css";
import "./tinymce/skins/content/default/content.min.css";
import "./tinymce/langs/zh_CN";
import req from "@/request";
import form from "@/api/form.js";
const manage = req.getContext().manage;
const portal = req.getContext().portal;
export default {
  name: "vueTinymceWrap",
  components: {
    Editor
  },
  data() {
    return {
      initData: {
        base_url: "/tinymce",
        language: "zh_CN",
        // 组件
        plugins: "lists image wordcount autoresize table",
        relative_urls: false,
        remove_script_host: false,
        elementpath: false,
        // 工具栏
        toolbar:
          "bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent  | undo redo | link unlink image  | removeformat | table",
        branding: false,
        width: "100%",
        max_height: 600,
        height: 350,
        domain: manage,
        // 图片本地上传方法  点击上传后执行的事件
        images_upload_handler: (blobInfo, success, failure) => {
          this.handleImgUpload(blobInfo, success, failure);
        }
      },
      currentValue: this.value
    };
  },
  props: {
    value: {
      type: String,
      default: () => ""
    }
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue;
    },
    currentValue(newValue) {
      this.$emit("input", newValue);
    }
  },
  methods: {
    handleImgUpload(blobInfo, success, failure) {
      let formData = new FormData();
      // append 方法中的第一个参数就是 我们要上传文件 在后台接收的文件名
      // 这个值要根据后台来定义
      // 第二个参数是我们上传的文件
      formData.append("file", blobInfo.blob());
      // axios 定义上传方法
      form.fileUpload(formData).then(res => {
        if (!res.success) {
          // 上传失败执行此方法，将失败信息填入参数中
          failure("HTTP Error: " + res.msg);
          return;
        }
        console.log(`${manage}${portal}/system/file/v1/downloadFile?fileId=${res.fileId}`)
        // 上传成功之后，将对应完整的图片路径拼接在success的参数中
        success(`${manage}${portal}/system/file/v1/downloadFile?fileId=${res.fileId}`);
      });
    }
  },
  mounted() {
    tinymce.init({});
  }
};
</script>

<style scoped></style>
